import { useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { loginData, logout } from "../../stores/auth"
import { axiosAuth, errorHandling } from "../../helpers"
import swal from "sweetalert"

const useAdminSatker = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const dataLogin = useSelector(loginData)
    const [data, setData] = useState([])
    const [isAdd, setIsAdd] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isValid, setIsValid] = useState(false)
    const [isPassValid, setIsPassValid] = useState(true)
    const [isSubmit, setIsSubmit] = useState(false)
    const [isAllowEdit, setIsAllowEdit] = useState(false)
    const [isAllowDelete, setIsAllowDelete] = useState(false)
    const [loading, setLoading] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [totalRows, setTotalRows] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [selectedRows, setSelectedRows] = useState([])
    const [formData, setFormData] = useState({
        nip: "",
        nama: "",
        no_hp: "",
        email: "",
        kode_satker: null,
        password: "",
        password_confirmation: "",
    })
    const [aplikasiId, setAplikasiId] = useState([null])
    const [roleAppId, setRoleAppId] = useState([null])
    const [valueRoleAppId, setValueRoleAppId] = useState([])
    const [listRoleAppId, setListRoleAppId] = useState([])
    const [listAplikasiId, setListAplikasiId] = useState([])
    const modalRef = useRef()
    const [isSubmitTrueOrFalse, setIsSubmitTrueOrFalse] = useState(false)
    const [dataTrueOrFalseModal, setDataTrueOrFalseModal] = useState({
        id: null,
        title: "",
        description: "",
    })

    // const [formDataSatker, setFormDataSatker] = useState({
    //     kode_satker_utama: ""
    // })
    const [formDataSatker, setFormDataSatker] = useState({
        kode_satker_utama: null, // 👈 not string
    })


    const [allSatker, setAllSatker] = useState([])
    const [allSatkerOptions, setAllSatkerOptions] = useState([])
    const getAllSatker = async (keyword = '') => {
        try {
            // setIsLoading(true)

            const response = await axiosAuth.get('/v1/satker', {
                params: {
                    keyword: keyword || undefined,
                },
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`,
                },
            })

            if (response.data.status_code === 200) {
                const reformattedArray = response.data.data.rows.map(
                    ({ satuan_kerja, kode_satuan_kerja }) => ({
                        value: kode_satuan_kerja,
                        label: satuan_kerja,
                    })
                )

                setAllSatkerOptions(reformattedArray)
            } else {
                swal(
                    'Terjadi Kesalahan',
                    'Silakan coba beberapa saat lagi atau hubungi developer',
                    'error'
                )
            }
        } catch (error) {
            console.error(error)
        } finally {
            // setIsLoading(false)
        }
    }
    useEffect(() => {
        getListAplikasiId()
        getAllSatker()
    }, [])

    const getListAplikasiId = async () => {
        try {
            const response = await axiosAuth.get(`/v1/aplikasi`, {
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`,
                }
            })
            if (response.data.status_code === 200) {
                setListAplikasiId(response.data.data.rows)
            }
        } catch (_) { }
    }

    const handleChangeFormData = (e) => {
        console.log(e);
        console.log(typeof (e));
        if (e.target) {
            const { name, value } = e.target
            console.log(value);

            setFormDataSatker({ ...formDataSatker, [name]: e.value })
        } else if (Array.isArray(e)) {
            const kepada_id = e.reduce((result, item) => {
                if (!result[item.key]) {
                    result[item.key] = [];
                }
                result[item.key].push({ value: item.value, label: item.label });
                return result;
            }, {});

            setFormData({ ...formDataSatker, kepada_id })
        } else {

            setFormData({ ...formDataSatker, [e.key]: e.value })
        }
    }

    const handleChangeForm = (e) => {

        if (e.target) {
            const { name, value } = e.target

            const newFormData = {
                ...formData,
                [name]: value
            }
            setFormData(newFormData)
        } else {
            if (e.key === "aplikasi_id") {
                const newAplikasiId = [...aplikasiId]
                newAplikasiId[e.index] = e
                setAplikasiId(newAplikasiId)
                const newRoleAppId = [...roleAppId]
                newRoleAppId[e.index] = e.roles.map((ex) => {
                    return {
                        "value": ex.id,
                        "label": ex.nama,
                        "index": e.index,
                        "key": "role_app_id"
                    }
                })
                setRoleAppId(newRoleAppId)
            } else if (e.key === "role_app_id") {
                const newListRoleAppId = [...listRoleAppId]
                newListRoleAppId[e.index] = e.value
                setListRoleAppId(newListRoleAppId)
                const newValueRoleAppId = [...valueRoleAppId]
                newValueRoleAppId[e.index] = e
                setValueRoleAppId(newValueRoleAppId)
            }
        }
        validateForm()
    }

    const validateForm = () => {
        if (isEdit) {
            if (
                formData.nip !== "" &&
                formData.nama !== "" &&
                formData.no_hp !== "" &&
                formData.email !== "" &&
                formDataSatker.kode_satker_utama !== ""
            ) {
                setIsValid(true)
            } else {
                setIsValid(false)
            }
        } else {
            if (
                formData.nip !== "" &&
                formData.nama !== "" &&
                formData.no_hp !== "" &&
                formData.email !== "" &&
                formDataSatker.kode_satker_utama !== "" &&
                formData.password !== "" &&
                formData.password_confirmation !== ""
            ) {
                setIsValid(true)
            } else {
                setIsValid(false)
            }
        }
    }

    const columns = useMemo(() => [
        {
            name: "NIP",
            selector: (row) => row.nip,
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Nama",
            selector: (row) => row.nama,
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "No. HP",
            selector: (row) => row.no_hp,
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Satker",
            selector: (row) => row.satker_utama,
            sortable: true,
            style: {
                fontSize: "14px",
            },
        },
    ], [])

    useEffect(() => {
        const delayDebouncer = setTimeout(() => {
            fetchData(1)
        }, 500)
        return () => clearTimeout(delayDebouncer)
    }, [keyword])

    const fetchData = async (page, size = perPage) => {
        setLoading(true)
        try {
            const response = await axiosAuth.get(`/v1/users`, {
                params: {
                    page: page,
                    limit: size,
                    keyword: keyword,
                    is_admin: true,
                },
                headers: {
                    'Authorization': `Bearer ${dataLogin.token_account}`,
                }
            });

            if (response.data.status_code === 200) {
                setData(response.data.data.rows ?? []);
                setTotalRows(response.data.data.total_rows);
                setLoading(false);
            } else {
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            setLoading(false)
        }
    }

    const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const handleRowSelected = (state) => {
        if (isEdit) {
            setIsEdit(false)
        }
        setSelectedRows(state.selectedRows)
        console.log(state.selectedRows)
        // let selectedOptionDari =
        //     { value: state.selectedRows.kode_satker_utama, label: state.selectedRows.data.satker_utama }
        // setFormDataSatker({ ...formDataSatker, kode_satker_utama: selectedOptionDari })
        setIsAllowEdit(state.selectedCount === 1)
        setIsAllowDelete(state.selectedCount === 1)
        if (state.selectedCount === 0) {
            setIsEdit(false)
        }
    }

    const handleShowForm = (yesEdit) => {
        if (yesEdit) {
            const newFormData = { ...formData }
            newFormData.nip = selectedRows[0].nip
            newFormData.nama = selectedRows[0].nama
            newFormData.no_hp = selectedRows[0].no_hp
            newFormData.email = selectedRows[0].email
            newFormData.kode_satker = selectedRows[0].kode_satker_utama
            // console.log(selectedRows[0].kode_satker_utama);
            const defaultOption = {
                value: selectedRows[0].kode_satker_utama ?? "",
                label: selectedRows[0].satker_utama ?? "",
            }

            setAllSatkerOptions(prev => {
                if (prev.some(opt => opt.value === defaultOption.value)) {
                    return prev
                }
                return [...prev, defaultOption]
            })

            setFormDataSatker({
                kode_satker_utama: defaultOption,
            })

            if (selectedRows[0].list_role) {

                const newAplikasiId = selectedRows[0]?.list_role?.map((e, i) => {
                    const roles = listAplikasiId.find(item => item.id === e.aplikasi.id).list_role
                    return {
                        value: e.id,
                        label: e.aplikasi.nama,
                        index: i,
                        key: "aplikasi_id",
                        roles: roles
                    }
                })
                setAplikasiId(newAplikasiId)

                const newRoleAppId = [...roleAppId]
                newAplikasiId?.map((e, i) => {
                    newRoleAppId[i] = e.roles.map((ex) => {
                        return {
                            "value": ex.id,
                            "label": ex.nama,
                            "index": e.index,
                            "key": "role_app_id"
                        }
                    })
                    setRoleAppId(newRoleAppId)
                })

                const newValueRoleAppId = selectedRows[0].list_role?.map((e, i) => {
                    var data = newRoleAppId[i].find((item => item.value === e.id))
                    return {
                        "value": data.value,
                        "label": data.label,
                        "index": data.index,
                        "key": "role_app_id"
                    }
                })
                setValueRoleAppId(newValueRoleAppId)
                const newListRoleAppId = newValueRoleAppId.map((e) => {
                    return e.value
                })
                setListRoleAppId(newListRoleAppId)
            }

            setFormData(newFormData)
            // setIsEdit(!isEdit)
            setIsEdit(true)
            setIsAdd(false)
        } else {
            setFormData({
                nip: "",
                nama: "",
                no_hp: "",
                email: "",
                kode_satker: "",
                password: "",
                password_confirmation: "",
            })
            setFormDataSatker({
                kode_satker_utama: ""
            })
            setIsEdit(false)
            // setIsAdd(!isAdd)
            setIsAdd(true)
        }
    }

    const handleOpenTrueOrFalseModal = () => {
        setDataTrueOrFalseModal({
            title: "Hapus Admin Satker",
            description: "Anda yakin menghapus Admin Satker ini sekarang?"
        })
        setTimeout(() => {
            const modal = new window.bootstrap.Modal(modalRef.current);
            modal.show();
        }, 100);
    }

    const handleSubmitForm = async (e) => {
        e.preventDefault()
        setIsSubmit(true)
        const PASSWORD_REGEX =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{10,}$/;
        const isPasswordStrong = PASSWORD_REGEX.test(formData.password);
        if (isEdit) {
            if (formData.password) {
                if (formData.password === formData.password_confirmation && isPasswordStrong) {
                    setIsPassValid(true)
                    doSubmitEditForm()
                } else {
                    setIsSubmit(false)
                    setIsPassValid(false)
                }
            } else {
                doSubmitEditForm()
            }
        } else {
            if (formData.password === formData.password_confirmation && isPasswordStrong) {
                doSubmitAddForm()
            } else {
                setIsSubmit(false)
                setIsPassValid(false)
            }
        }
    }

    const doSubmitEditForm = async () => {
        try {
            const payload = {
                ...formData,
                is_admin: true,
                kode_satker: formDataSatker.kode_satker_utama?.value ?? "",
            }

            // const response = await axiosAuth.put(`/v1/admin/users/${selectedRows[0].id}`, formData, {
            const response = await axiosAuth.put(`/v1/admin/users/update/${selectedRows[0].id}`, payload, {
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`
                }
            })

            if (response.data.status_code === 200) {
                handleAssignRole(response.data.data.id)
            } else {
                setIsSubmit(false)
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            setIsSubmit(false)
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        }
    }

    const doSubmitAddForm = async () => {
        setIsPassValid(true)
        try {
            const payload = {
                ...formData,
                is_admin: true,
                kode_satker: formDataSatker.kode_satker_utama.value ?? "",
            }

            const response = await axiosAuth.post(`/v1/admin/users`, payload, {
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`
                }
            })

            if (response.data.status_code === 200) {
                handleAssignRole(response.data.data.id)
            } else {
                setIsSubmit(false)
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            setIsSubmit(false)
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        }
    }

    const handleAssignRole = async (id) => {
        try {
            const response = await axiosAuth.put(`/v1/admin/users/${id}`, { "role_ids": listRoleAppId },
                {
                    headers: {
                        Authorization: `Bearer ${dataLogin.token_account}`
                    }
                }
            )
            if (response.data.status_code === 200) {
                if (isEdit) {
                    swal("Berhasil", "Admin Satker berhasil diupdate", "success")
                } else {
                    swal("Berhasil", "Admin Satker berhasil ditambahkan", "success")
                }
                setTimeout(() => {
                    window.location.reload()
                }, 2500);
            } else {
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        } finally {
            setIsSubmit(false)
        }
    }

    const handleAddAplikasiId = () => {
        const newAplikasiId = [...aplikasiId, null]
        setAplikasiId(newAplikasiId)
    }

    const handleDeleteAplikasiId = (index) => {
        const newAplikasiId = aplikasiId.filter((_, i) => i !== index);
        setAplikasiId(newAplikasiId)
    }

    const handleSubmitTrueOrFalse = async (e) => {
        e.preventDefault()
        try {
            const response = await axiosAuth.delete(`/v1/admin/users/${selectedRows[0].id}`, {
                headers: {
                    Authorization: `Bearer ${dataLogin.token_account}`
                }
            })

            if (response.data.status_code === 200) {
                swal("Berhasil", "Admin Satker berhasil dihapus", "success")
                setTimeout(() => {
                    window.location.reload()
                }, 2500);
            } else {
                setIsSubmit(false)
                swal('Terjadi Kesalahan', "Silakan coba beberapa saat lagi atau hubungi developer", 'error')
            }
        } catch (err) {
            setIsSubmit(false)
            swal('Error', errorHandling(err), 'error')
            if (err.status === 401) {
                dispatch(logout())
            }
        }
    }

    const handleResetOTP = async () => {
        if (selectedRows.length === 0) return;

        // Using swal for confirmation before proceeding
        const willReset = await swal({
            title: "Reset MFA/OTP?",
            text: `Apakah Anda yakin ingin mereset MFA untuk user ${selectedRows[0].nama}?`,
            icon: "warning",
            buttons: ["Batal", "Ya, Reset"],
            dangerMode: true,
        });

        if (willReset) {
            setLoading(true);
            try {
                const payload = {
                    id: selectedRows[0].id // Adjust this if the ID property name is different (e.g. userId)
                };

                const response = await axiosAuth.post(`/v1/admin/users/reset-otp`, payload, {
                    headers: {
                        Authorization: `Bearer ${dataLogin.token_account}`
                    }
                });

                if (response.data.status_code === 200) {
                    swal("Berhasil", "MFA/OTP user telah berhasil di-reset", "success");
                    fetchData(currentPage); // Refresh current page data
                } else {
                    swal("Gagal", "Gagal mereset MFA. Silakan coba lagi.", "error");
                }
            } catch (err) {
                swal("Error", errorHandling(err), "error");
                if (err.status === 401) {
                    dispatch(logout());
                }
            } finally {
                setLoading(false);
            }
        }
    };

    return {
        data,
        isAdd,
        isEdit,
        isValid,
        isSubmit,
        columns,
        loading,
        perPage,
        formData,
        totalRows,
        roleAppId,
        aplikasiId,
        currentPage,
        isPassValid,
        isAllowEdit,
        selectedRows,
        isAllowDelete,
        valueRoleAppId,
        modalRef,
        isSubmitTrueOrFalse,
        dataTrueOrFalseModal,
        handleSubmitTrueOrFalse,
        handleOpenTrueOrFalseModal,
        dispatch,
        navigate,
        handleShowForm,
        handleSubmitForm,
        handlePageChange,
        handleChangeForm,
        handleRowSelected,
        handlePerRowsChange,
        handleAddAplikasiId,
        handleDeleteAplikasiId,
        allSatker,
        allSatkerOptions,
        getAllSatker,
        handleChangeFormData,
        formDataSatker,
        setFormDataSatker,
        handleResetOTP,
    }
}

export default useAdminSatker